// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__25Hs8","content":"Footer_content__e3nzi","logo":"Footer_logo__1yyNQ","trademark":"Footer_trademark__1ajm4","appVersion":"Footer_appVersion__1dgY0"};